import React, { useState, useEffect } from 'react'
import { saveEmailToSupabase } from '../services/emailService'

const PopUpNewsletter = () => {
  const [isVisible, setIsVisible] = useState(false)
  const [email, setEmail] = useState('')
  const [emailError, setEmailError] = useState('')
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [saveSuccess, setSaveSuccess] = useState(false)

  useEffect(() => {
    // Comprobar si el popup ya se ha mostrado en esta sesión
    const hasBeenShown = localStorage.getItem('newsletterPopupShown')

    if (!hasBeenShown) {
      // Mostrar el pop-up después de 5 segundos para testing (luego cambiar a 120000 ms = 2 minutos)
      const timer = setTimeout(() => {
        setIsVisible(true)
      }, 110000)

      return () => clearTimeout(timer)
    }
  }, [])

  const handleClose = () => {
    setIsVisible(false)
    // Guardar en localStorage para no mostrar de nuevo en esta sesión
    localStorage.setItem('newsletterPopupShown', 'true')
  }

  const handleBackdropClick = (e) => {
    // Cerrar el popup si se hace clic en el fondo (no en el contenido)
    if (e.target === e.currentTarget) {
      handleClose()
    }
  }

  const handleEmailChange = (e) => {
    setEmail(e.target.value)
    setEmailError('')
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setEmailError('')
    setSaveSuccess(false)

    // Validate email format
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    if (!emailRegex.test(email)) {
      setEmailError('Por favor, introduce un email válido')
      return
    }

    setIsSubmitting(true)

    try {
      // Save email to Supabase
      const result = await saveEmailToSupabase(email)

      if (result.success) {
        setSaveSuccess(true)
        // Redirect to Substack after a short delay
        setTimeout(() => {
          window.location.href = 'https://conversoriaecnae.substack.com/embed'
          // Guardar en localStorage para no mostrar de nuevo en esta sesión
          localStorage.setItem('newsletterPopupShown', 'true')
        }, 1500)
      } else {
        setEmailError(
          'Error al guardar el email. Por favor, inténtalo de nuevo.'
        )
        setIsSubmitting(false)
      }
    } catch (error) {
      console.error('Error in form submission:', error)
      setEmailError(
        'Error al procesar la solicitud. Por favor, inténtalo de nuevo.'
      )
      setIsSubmitting(false)
    }
  }

  // Si no es visible, no renderizar nada
  if (!isVisible) return null

  return (
    <div
      className='fixed inset-0 z-50 flex items-center justify-center p-4 bg-black bg-opacity-50'
      onClick={handleBackdropClick}
      aria-modal='true'
      role='dialog'
    >
      <div className='bg-card max-w-md w-full rounded-lg shadow-lg overflow-hidden relative'>
        {/* Botón de cerrar */}
        <button
          onClick={handleClose}
          className='absolute top-3 right-3 text-text-secondary hover:text-text-primary'
          aria-label='Cerrar'
        >
          <svg
            xmlns='http://www.w3.org/2000/svg'
            className='h-6 w-6'
            fill='none'
            viewBox='0 0 24 24'
            stroke='currentColor'
          >
            <path
              strokeLinecap='round'
              strokeLinejoin='round'
              strokeWidth={2}
              d='M6 18L18 6M6 6l12 12'
            />
          </svg>
        </button>

        {/* Contenido del pop-up */}
        <div className='p-6'>
          <h2 className='text-2xl md:text-3xl font-bold text-center mb-4'>
            ¡Mantente al día!
          </h2>

          <div className='flex justify-center mb-4'>
            <img
              src='/resources/images/New-message-cuate.svg'
              alt='Newsletter'
              className='w-40 h-40'
            />
          </div>

          <p className='text-text-secondary text-center mb-6'>
            Recibe los últimos artículos y actualizaciones sobre códigos IAE y
            CNAE directamente en tu bandeja de entrada. Además, te enviaremos
            recomendaciones especiales cada semana.
          </p>

          {saveSuccess ? (
            <div className='text-center text-green-500 mb-4'>
              ¡Gracias por suscribirte! Redirigiendo...
            </div>
          ) : (
            <form onSubmit={handleSubmit} className='space-y-4'>
              <div className='relative'>
                <input
                  type='email'
                  value={email}
                  onChange={handleEmailChange}
                  placeholder='Tu Email'
                  className={`p-3 rounded-md border-2 ${
                    emailError
                      ? 'border-red-500'
                      : 'border-text-secondary border-opacity-30'
                  } bg-transparent text-text-primary w-full`}
                  required
                />
                {emailError && (
                  <p className='text-red-500 text-sm mt-1'>{emailError}</p>
                )}
              </div>

              <button
                type='submit'
                disabled={isSubmitting}
                className='bg-primary hover:bg-opacity-90 text-background font-medium py-3 px-6 rounded-md w-full transition-colors'
              >
                {isSubmitting ? 'Procesando...' : 'Suscribirme'}
              </button>
            </form>
          )}

          <div className='flex items-center justify-center mt-4 text-xs text-text-secondary'>
            <svg
              xmlns='http://www.w3.org/2000/svg'
              className='h-4 w-4 mr-1'
              fill='none'
              viewBox='0 0 24 24'
              stroke='currentColor'
            >
              <path
                strokeLinecap='round'
                strokeLinejoin='round'
                strokeWidth={2}
                d='M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z'
              />
            </svg>
            <span>
              Respetamos tu privacidad. No compartimos tus datos con terceros.
            </span>
          </div>
        </div>
      </div>
    </div>
  )
}

export default PopUpNewsletter
